import BackTop from './back-top.vue';
export default BackTop;


// WEBPACK FOOTER //
// ./src/components/back-top/index.js